import { render, staticRenderFns } from "./MigrationForms.vue?vue&type=template&id=5788a97a&scoped=true"
import script from "./MigrationForms.vue?vue&type=script&setup=true&lang=js"
export * from "./MigrationForms.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MigrationForms.vue?vue&type=style&index=0&id=5788a97a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5788a97a",
  null
  
)

export default component.exports